// extracted by mini-css-extract-plugin
export default {"filters":"CaseDocumentFilters_filters__Uzbya"};